import React from 'react';
import { motion } from 'framer-motion';
import { InfoIcon } from 'lucide-react';
export function RequirementsNotice() {
  return <section className="py-12 px-6 bg-[var(--white-smoke)]" data-id="element-207">
      <div className="max-w-4xl mx-auto" data-id="element-208">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-blue-50 border-l-4 border-blue-500 rounded-lg p-6" data-id="element-209">
          <div className="flex items-start gap-4" data-id="element-210">
            <InfoIcon className="w-6 h-6 text-blue-600 flex-shrink-0 mt-1" data-id="element-211" />
            <div data-id="element-212">
              <h3 className="text-lg font-bold text-blue-900 mb-2" data-id="element-213">
                What We'll Need From You
              </h3>
              <p className="text-blue-800 mb-3" data-id="element-214">
                To set everything up, we'll need access to a few things (don't
                worry, we'll walk you through it):
              </p>
              <ul className="space-y-2 text-sm text-blue-800" data-id="element-215">
                <li className="flex items-start gap-2" data-id="element-216">
                  <span className="text-blue-600" data-id="element-217">1.</span>
                  <span data-id="element-218">
                    <strong data-id="element-219">Your messaging platform:</strong> Login for Yelp,
                    Facebook, or Instagram (whichever you choose)
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-220">
                  <span className="text-blue-600" data-id="element-221">2.</span>
                  <span data-id="element-222">
                    <strong data-id="element-223">Your Google Calendar:</strong> So we can add
                    bookings automatically
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-224">
                  <span className="text-blue-600" data-id="element-225">3.</span>
                  <span data-id="element-226">
                    <strong data-id="element-227">Your CRM (if you have one):</strong> We can connect
                    it so everything syncs
                  </span>
                </li>
              </ul>
              <p className="text-sm text-blue-700 mt-4 italic" data-id="element-228">
                We use secure connections and never share your info. You can
                revoke access anytime.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}